module.exports = __webpack_public_path__ + "img/heart.8e013006.svg";